const messages = {
  title: "Bonus multiplicator",
  bandBonusTitle: "Bonus per tyre at multiplicator",
  amountLabel: "Min. number of tyres (*)",
  label: "Bonus multiplicator",
  desc: "Number of Bridgestone and Firestone tyres. There is no bonus in euros on Firestone tyres.",
  goals: {
    loyal: "Loyal",
    bronze: "Bronze",
    silver: "Silver",
    gold: "Gold",
    platinum: "Platinum",
  },
  andMore: "and more",
  chooseTarget: "Select",
  selectTarget: "Select your annual target for {year} here:",
  multiplication: "Bonus is multiplied by <b>{factor}</b>",
  minTyres: "<b>Minimum:</b> {tyre} tyres",
};

export default {
  messages,
};
